import React from 'react';
import ToastMessagesListContainer from './ToastMessagesList/ToastMessagesListContainer';
import wrapWithProvider from '@Utils/Components/wrapWithProvider';

const renderToastMessagesListContainer = wrapWithProvider(<ToastMessagesListContainer />);

export default function init() {
  const root = document.createElement('div');
  root.setAttribute('class', 'toast-message-root');
  document.body.appendChild(root);

  renderToastMessagesListContainer(root);
}
